import { inject, Injectable, OnDestroy } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { catchError, Observable, of, tap } from 'rxjs';
import { SeatStatusPayloadNotification } from '../models/notification.model';
import { LoggerService } from '@core/services/logger.service';
import { NotificationHubService } from '@core/services/notifications/NotificationHub.service';
import { SalesEventTypeEnum } from '@sales/models/sales.model';

@Injectable({
  providedIn: 'root',
})
export class SalesPlanBlockViewNotificationService implements OnDestroy {
  private hubConnection: HubConnection | undefined;

  private readonly notifHubService = inject(NotificationHubService);
  private readonly loggerService = inject(LoggerService);

  ngOnDestroy() {
    this.notifHubService.removeHubListeners();
  }

  public get connectionId() {
    return this.hubConnection.connectionId;
  }

  initForSubscription(subscriptionId: number): Observable<void> {
    return this.notifHubService.joinSubscriptionRoom(subscriptionId).pipe(
      tap(() => this.loggerService.info('T&L - Joined subscription room')),
      catchError((err) => {
        this.loggerService.error('T&L - Failed to initialize notification connection or room:', err);
        return of(void 0);
      }),
    );
  }

  initForEventSession(eventSessionId: number): Observable<void> {
    return this.notifHubService.joinEventSessionRoom(eventSessionId).pipe(
      tap(() => this.loggerService.info('T&L - Joined event session room:', eventSessionId)),
      catchError((err) => {
        this.loggerService.error('T&L - notification connection failed. Switching to degraded mode.', err);
        return of(void 0);
      }),
    );
  }

  seatStatuses$(): Observable<SeatStatusPayloadNotification[]> {
    return this.notifHubService.seatStatuses$();
  }

  leaveGroup(eventType: SalesEventTypeEnum, roomId: number) {
    if (eventType === SalesEventTypeEnum.Event) {
      return this.notifHubService.leaveGroupEventSession(roomId).subscribe();
    } else {
      return this.notifHubService.leaveGroupSubscription(roomId).subscribe();
    }
  }
}
